import { DatabaseModel } from '../class/database-model.class';
import { Link } from '../class/link.class';
import { Table } from '../class/table.class';
import { SavedDatabaseModel } from '../saved/saved-database-model.type';
import { SavedLink } from '../saved/saved-link.type';
import { SavedTable } from '../saved/saved-table.type';
import { ToCreateDatabaseModel } from '../to-create/to-create-database-model.type';
import { ToCreateLink } from '../to-create/to-create-link.type';
import { ToCreateTable } from '../to-create/to-create-table.type';

export class DatabaseModelBuilder {
  public static buildFromClass(odlModel: DatabaseModel): DatabaseModel {
    const model = new DatabaseModel(odlModel.getTitle(), [...odlModel.getTableList()], [...odlModel.getLinkList()]);
    model.setId(odlModel.getId()).setUserId(odlModel.getUserId());
    for (const table of model.getTableList()) {
      table.setDatabaseModelId(model.getId());
    }
    for (const link of model.getLinkList()) {
      link.setDatabaseModelId(model.getId());
    }
    return model;
  }

  public static buildWithNewTitle(odlModel: DatabaseModel, newTitle: string): DatabaseModel {
    const model = this.buildFromClass(odlModel);
    model.setTitle(newTitle);
    return model;
  }

  public static buildFromSavedDto(dto: SavedDatabaseModel): DatabaseModel {
    const tableList: Table[] = dto.tableList.map((table: SavedTable) => Table.mapFromSaved(table));
    const linkList: Link[] = dto.linkList.map((link: SavedLink) => Link.mapFromSaved(link));
    const model: DatabaseModel = new DatabaseModel(dto.title, tableList, linkList);
    model.setId(dto.id);
    model.setUserId(dto.userId);
    return model;
  }

  public static buildToCreate(model: DatabaseModel): ToCreateDatabaseModel {
    const tableList: ToCreateTable[] = model.getTableList().map((table: Table) => Table.mapToCreate(table));
    const linkList: ToCreateLink[] = model.getLinkList().map((link: Link) => Link.mapToToCreate(link));
    return {
      title: model.getTitle(),
      tableList: tableList,
      linkList: linkList,
    };
  }

  public static buildToSaved(model: DatabaseModel): SavedDatabaseModel {
    const tableList: SavedTable[] = model.getTableList().map((table: Table) => Table.mapToSaved(table));
    const linkList: SavedLink[] = model.getLinkList().map((link: Link) => Link.mapToSaved(link));
    return {
      id: model.getId() as number,
      title: model.getTitle(),
      tableList: tableList,
      linkList: linkList,
      userId: model.getUserId() as number,
    };
  }

  public static buildEmptyModel(): DatabaseModel {
    return new DatabaseModel('', [], []);
  }
}
